import { _ as _extends } from './extends-3e8335ef.esm.js';
import React__default from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { A as AppAssets } from './index-fa849583.esm.js';
import { u as useTheme } from './useTheme-e658d3b6.esm.js';
import { A as AppText, a as AppIcon } from './index-495429ce.esm.js';
import { A as AppActivityIndicator } from './index-5a30f9d1.esm.js';

const AppTextChip = _ref => {
  let {
    item,
    label,
    onDeleteClick,
    styleContainer,
    styleDelete,
    styleLabel,
    isTagDeletable,
    backgroundColor,
    fontColor,
    borderColor,
    iconSize = 16,
    borderRadius = 25,
    showProgressIndicator,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const _style = generateStyle(currentTheme, backgroundColor, borderColor, fontColor, borderRadius);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [_style.styleContainer, styleContainer]
  }, /*#__PURE__*/React__default.createElement(AppActivityIndicator, {
    visible: showProgressIndicator,
    containerStyle: {
      alignItems: "flex-start",
      flex: 0,
      flexBasis: 24
    },
    size: 12,
    backgroundColor: currentTheme?.theme?.transparent
  }), /*#__PURE__*/React__default.createElement(AppText, _extends({
    iconSize: iconSize
  }, props, {
    style: [_style.styleLabel, styleLabel]
  }), label), isTagDeletable && /*#__PURE__*/React__default.createElement(TouchableOpacity, {
    onPress: () => onDeleteClick(item || label)
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    style: [_style.styleDelete, styleDelete],
    icon: AppAssets.icons.close,
    size: iconSize,
    color: currentTheme?.theme?.red
  })));
};
const generateStyle = (props, backgroundColor, borderColor, fontColor, borderRadius) => {
  return StyleSheet.create({
    styleDelete: {
      marginLeft: 10
    },
    styleLabel: {
      color: fontColor || props?.theme?.font_color
    },
    styleContainer: {
      marginRight: 5,
      marginLeft: 5,
      paddingHorizontal: 10,
      paddingVertical: 5,
      backgroundColor: backgroundColor || props?.theme?.backgroundColor,
      borderRadius: borderRadius,
      borderWidth: 1,
      borderColor: borderColor || props?.theme?.primary,
      alignContent: "center",
      display: "flex",
      justifyContent: "space-around",
      flexDirection: "row",
      alignItems: "center"
    }
  });
};
AppTextChip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppTextChip",
  "props": {
    "iconSize": {
      "defaultValue": {
        "value": "16",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Icon size applied to both leftIcon displayed in the text input and delete icon"
    },
    "borderRadius": {
      "defaultValue": {
        "value": "25",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Border radius applied to the view wrapping all sub-components"
    },
    "item": {
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": "Generic passed to manage a more complex set of objects"
    },
    "label": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Text displayed next to the input field"
    },
    "onDeleteClick": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(item: any) => void",
        "signature": {
          "arguments": [{
            "name": "item",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event raised when the user clicks the delete icon in one of the AppTextChips - available only when isTagDeletable is marked true"
    },
    "styleContainer": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of view wrapping all sub-components"
    },
    "styleDelete": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of delete icon - available only when isTagDeletable is marked true"
    },
    "styleLabel": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "TextStyle"
        }],
        "raw": "StyleProp<TextStyle>"
      },
      "description": "Style of the text text displayed next to the input field"
    },
    "isTagDeletable": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true renders the a delete icon inside each tag allowing the user to delete it from the selection"
    },
    "backgroundColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Background color applied to the entire component"
    },
    "fontColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Font color applied to the entire component"
    },
    "borderColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Border color applied to the view wrapping all sub-components"
    },
    "leftIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": "Icon displayed on the left hand side of the input field"
    },
    "showProgressIndicator": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true renders a progress indicator inside the component"
    }
  }
};

export { AppTextChip as A };
